var React = require('react');

function CheckBadge (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z","key":0}),React.createElement("path",{"d":"m9 12 2 2 4-4","key":1})]);
}

CheckBadge.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"lucide lucide-badge-check-icon lucide-badge-check"};

module.exports = CheckBadge;

CheckBadge.default = CheckBadge;
